export const agent = {
  yqmh: "블라인드 박스 초대",
  yqzmh: "블라인드 박스 획득을 위한 초대",
  bfbkj: "100% 경품 추첨",
  yqpy: "친구 초대",
  pywczcrw: "친구 등록 및 작업 완료",
  hdcmhcs: "블라인드 박스 추첨 횟수를 얻으세요",
  jllb: "보상 목록",
  mhjlbk: "블라인드 박스 보상에는 다음이 포함될 수 있습니다: {text} 특정 금액은 실제로 받은 보상에 따라 달라집니다!",
  kkcs: "{value}번 열 수 있음",
  mhmx: "블라인드 박스 세부 정보",
  jpmx: "상금 세부 정보",
  hdmhs: "획득한 블라인드 박스 수",
  hyjd: "친구 진행 상황",
  jplx: "상 종류",
  dbmc: "토큰 이름",
  ypf: "분산",
  wpf: "발송되지 않음",
  lq: "수신",
  zblw: "주변의 선물",
  gxczmh: "{amount} 당첨 축하드립니다. 새로운 친구를 초대하고, 과제를 완료하고, 블라인드 박스를 받으세요",
  lxkflq: "주변 선물 보상에 대해서는 고객 서비스에 문의하세요",
  shdz: "배달 주소",
  rwmc: "작업 이름",
  wczt: "완료 상태",
  hdmhsl: "블라인드 박스의 개수를 얻으세요",
  zblqdz: "근처 픽업 주소",
  shr: "수취인",
  dh: "전화",
  xxdz: "상세 주소",
  yqmhhdgz: "초대장 블라인드 박스 활동 규칙",
  yqyl: "1. Biking 초대 선물은 무엇인가요?",
  yhhkxt: "Biking 초대 선물은 Biking 사용자 피드백 시스템으로, Biking을 알아보고 친구를 Biking에 초대해 주신 모든 충성스러운 사용자에게 보답하는 것을 목표로 합니다.",
  yqhyhdfhjl: "Biking 초대 선물은 간단하고 사용하기 쉽습니다. 친구만 초대하면 풍성한 보상을 받을 수 있습니다.",
  cyhdhqjl: "2. 이벤트에 참여하고 과제를 완수하면 어떤 보상을 받을 수 있나요?",
  hywcrwhdjl: "초대자가 친구를 초대하면, 친구들은 해당 임무를 완료합니다. 초대자와 초대받는 사람 모두 블라인드 박스를 받을 수 있으며, 블라인드 박스를 열어 보상을 획득할 수 있습니다.",
  mhhdgz: "3. 블라인드 박스 획득 규칙",
  syrwczc: "1. 초대받은 사람이 등록 및 실명 확인을 완료합니다. 초대받은 사람은 계정을 활성화할 수 있는 한 번의 기회를 얻습니다.",
  syrcz: "2. 초대받은 사람이 100 USDT 이상을 입금하면 초대자와 초대받은 사람 모두 계좌 개설 기회를 1회씩 얻습니다.",
  syrcssxf: "3. 초대받는 사람의 계약 수수료는 ≥30USDT입니다. 초대자와 초대받는 사람은 각각 2회의 개통 기회를 얻습니다.",
  qqjyl: "4. 옵션 거래량 ≥ 200 USDT - 초대자와 초대받은 사람 각각 2회의 개시 기회를 얻습니다",
  yxjyl: "5. Gamefi 거래량이 200 USDT 이상이고 주문 배당률이 1.2배 이상인 경우, 배당률이 1.2배 미만인 주문은 계산되지 않습니다. 초대자와 초대받은 사람 각각 2회의 오픈 기회가 주어집니다.",
  xhmrjyl: "6. 현물 매수 거래량 ≥ 500 USTD - 초대자와 초대 대상자 각각 1회씩의 개시 기회를 얻습니다.",
  rwqbwc: "모든 초대 과제가 매번 완료되면 초대자는 블라인드 박스를 열 수 있는 기회를 최대 8번까지 얻을 수 있으며, 초대받은 사람이 모두 완료하면 블라인드 박스를 열 수 있는 기회를 최대 9번까지 얻을 수 있습니다. 여러 사람을 초대하면 규칙에 따라 블라인드 박스를 얻을 확률이 누적적으로 증가합니다.",
  qtsm: "4. 기타 지침",
  mhffsj: "1. 블라인드 박스 배포 시간 - 10분마다 갱신",
  jlffsj: "2. 보상 분배 시간 - 백엔드는 매일 정오 12시에 보상을 분배합니다.",
  syyhjkcj: "3. 모든 사용자가 참여할 수 있으며 다른 활동과 충돌하지 않습니다.",
  mhcjs: "4. 블라인드 박스 추첨 횟수는 매월 1일에 초기화됩니다.",
  yqmts: "사용자를 하위 계정으로 초대해야 하며, 하위 계정 거래는 수수료를 발생시킵니다.",
  fym: "리베이트 코드",
  fymts: "자신의 비율보다 높지 않은 하위 사용자를 초대하고 직접 리베이트 비율을 열면 하위 거래에 비례하여 수수료가 할당됩니다.",
  szfym: "할인 코드 설정",
  xzfym: "새로운 할인 코드 추가",
  lj: "링크",
  fybl: "할인율",
  yyqhys: "초대된 친구 수",
  sykcjs: "나머지는 생성될 수 있습니다",
  tjlx: "추천 유형",
  bwjs: "5. 개인이나 팀이 블라인드 박스 혜택을 이용한 것으로 확인될 경우, 코인킹은 계정 혜택 자격을 박탈하거나 취소할 권리가 있습니다. 이 혜택에 참여하는 모든 사용자는 공식 혜택 약관에 동의한 것으로 간주되며, 코인킹 거래소는 최종 해석권을 보유합니다.",
  swmr: "기본값으로 설정",
  cffym: "할인 코드가 중복되었습니다. 올바른 할인 코드를 입력하세요.",
  qxtjfym: "먼저 할인 코드를 추가해 주세요",
  xywdbl: "10 <= 내 할인율",
  qsrdybl: "해당 비율을 입력하세요",
  qsrzqsl: "올바른 값을 입력하세요",
  qsrbz: "비고를 입력해 주세요",
  bnbhzf: "특수 문자나 이모티콘을 포함할 수 없습니다",
  pfjj: "배포가 거부되었습니다.",
  pfsb: "보상 지급에 실패했습니다.",
  lxkf: "자세한 내용은 고객 서비스에 문의하세요.",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/kr.js